import type { RouteRecordRaw, } from 'vue-router';

const commonRoutes: Array<RouteRecordRaw> = [
  {
    path: '/alpsConfigList',
    name: 'alpsConfigList',
    meta: {
      title: 'alpsConfigList',
    },
    component: () => import('@/views/index/index.vue'),
  },
  {
    path: '/fyConfigList',
    name: 'fyConfigList',
    meta: {
      title: 'fyConfigList',
    },
    component: () => import('@/views/index/index.vue'),
  },
  {
    path: '/index',
    name: 'ConfigurationDetail',
    meta: {
      title: '详细配置表',
    },
    component: () => import('@/views/index/index.vue'),
  },
  {
    path: '/vehicle/configuration/:model_code',
    name: 'VehicleConfiguration',
    meta: {
      title: '详细配置表',
    },
    component: () => import('@/views/index/index.vue'),
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/index',
  },
];

export default commonRoutes;
